import { Link } from "react-router-dom";
import { AuthLayout } from "../components/Layouts/AuthLayout";
import { PasswordResetForm } from "../components/Form/Forms/Auth/PasswordResetForm";
import { useState } from "react";
import { useRequestPasswordReset } from "../api/hooks";
import { motion } from "framer-motion";

export function ResetPassword() {
  const [submitted, setSubmitted] = useState(false);
  const { mutate, isLoading } = useRequestPasswordReset();

  const onSubmit = (data) => {
    mutate(data.email, {
      onSuccess: () => setSubmitted(true),
    });
  };

  return (
    <AuthLayout>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md bg-white/90 backdrop-blur-xl rounded-3xl p-10 border border-gray-200"
      >
        {submitted ? (
          <div className="text-center">
            <h2 className="text-2xl font-semibold">Check your email</h2>
            <p className="mt-4 text-gray-600 text-sm">
              If the provided email matched our records, we've sent instructions for resetting your password.
            </p>
            <div className="mt-6">
              <Link to="/login" className="text-blue font-medium hover:underline text-sm">
                Return to sign in
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <h2 className="text-2xl font-semibold text-center">Reset your password</h2>
            <p className="mt-2 text-gray-500 text-sm text-center">
              Enter the email associated with your account to receive a reset link.
            </p>
            <div className="mt-6">
              <PasswordResetForm onSubmit={onSubmit} isLoading={isLoading} />
            </div>
            <p className="mt-6 text-center text-sm text-gray-600">
              Already have an account?{" "}
              <Link to="/login" className="text-blue font-medium hover:underline">
                Sign in
              </Link>
            </p>
          </div>
        )}
      </motion.div>
    </AuthLayout>
  );
}